const resetPasswordEndpointParamsSchema = (password, confirmPassword) => ({
  password,
  password_confirmation: confirmPassword,
});

export default resetPasswordEndpointParamsSchema;



// WEBPACK FOOTER //
// ./src/containers/ResetPassword/schemas.js